import Vue from 'vue'
import router from './router'
import store from './store'

const whiteList = ['/User/Login', '/User/Register', '/User/RefereeLogin'] // no redirect whitelist
router.beforeEach((to, from, next) => {
  // 白名单
  if (whiteList.includes(to.path)) {
    next()
  } else {
    // 没有登录
    if (!store.getters['user/accessToken']) {
      // 重定向到登录界面
      next({ path: '/User/Login'})
    } else {
      // 如果已经选择了一个机构，那就拿取这个机构的菜单权限
      if (store.getters['user/userInfo']) {
        let auth = store.getters['user/authMenuTree']
        if (auth.length === 0) {
          store.dispatch('user/MenuTree').then(menu => {
            router.addRoutes(menu)
          })
          .catch((error) => {
            console.warn('生成路由出现异常', error)
            store.dispatch('Logout').then(() => {
              // 重定向到登录界面
              next({ path: '/User/Login'})
            })
          })
        }
      }
      next()
    }
  }
})
// 按钮操作权限
const action = Vue.directive('action', {
  /**
   * vue 属性绑定
   * @param {*} el htmldom
   * @param {*} binding 绑定的值
   * @param {*} vnode 虚拟dom节点
   */
  bind: function (el, binding, vnode) {
    const actionName = binding.arg
    const actionAry = vnode.context.$route.meta.permissions
    if (actionAry !== undefined && actionAry.indexOf(actionName) === -1) {
      el.style.display = 'none'
      return false
    }
  }
})

// 按钮操作权限
const look = Vue.directive('look', {
  /**
   * vue 属性绑定
   * @param {*} el htmldom
   * @param {*} binding 绑定的值
   * @param {*} vnode 虚拟dom节点
   */
  bind: function (el, binding, vnode) {
    const actionName = binding.arg
    const actions = vnode.context.$route.meta.permissions.find((val) => {
        return actionName.includes(val)
    })
    if (!actions) {
      el.innerHTML = '<p>您没有权限访问！</p>'
    }
  }
})

export {
  action,
  look
}



// WEBPACK FOOTER //
// ./src/permission.js